<div class="ws-category-nav">
  <!--Desktop-->
  @if (!uiContext.isXs()) {
    <div class="ws-category-nav__list">
      @for (category of linkCategories; track category.id) {
        <a class="ws-category-nav__item"
           [class.ws-category-nav__item--active]="category.id === activeCategory?.id"
           [href]="urlPrefix ? '/' + urlPrefix + category.nameId : '#'"
           (click)="$event.preventDefault(); selectCategory(category)">
          {{ category.name }}
        </a>
      }
      @if (dropdownCategories && dropdownCategories.length) {
        <div class="ws-category-nav__more" ngbDropdown #dropdown="ngbDropdown"
             (click)="$event.stopPropagation()">
          <button class="ws-category-nav__more-toggle"
                  ngbDropdownToggle
                  (click)="$event.stopPropagation()"
                  [class.ws-category-nav__more-toggle--active]="selectedDropdownCategory">
            {{ selectedDropdownCategory ? selectedDropdownCategory.name : ('common.showMore' | translate) }}
          </button>
          <div class="dropdown-menu ws-dropdown ws-category-nav__more-menu" ngbDropdownMenu>
            @for (category of dropdownCategories; track category.id) {
              @if (category.id !== selectedDropdownCategory?.id) {
                <span class="dropdown-item ws-dropdown__item ws-category-nav__more-item"
                      (click)="$event.preventDefault(); dropdownSelectCategory(category); dropdown.close()">
                  {{ category.name }}
                </span>
              }
            }
          </div>
        </div>
      }
    </div>
  }
  <!--  Mobile-->
  @if (uiContext.isXs()) {
    <categories-mobile-selector
      [categories]="dropdownCategories"
      [selectedCategory]="activeCategory"
      [containerOffsetTop]="containerOffsetTop"
      (onCategorySelected)="dropdownSelectCategory($event)"
    ></categories-mobile-selector>
  }
</div>
